/// <reference path="../../types/images.d.ts" />
import backerConsult from "./assets/customers/backer-consult.png";
import bhsLogistics from "./assets/customers/bhs-logistics.webp";
import cloudfactory from "./assets/customers/cloudfactory.png";
import cykelmakker from "./assets/customers/cykelmakker.png";
import evidensia from "./assets/customers/evidensia.webp";
import familieteknikeren from "./assets/customers/familieteknikeren.png";
import flexkapacitet from "./assets/customers/flexkapacitet.webp";
import geckoBooking from "./assets/customers/gecko-booking.webp";
import hmGroup from "./assets/customers/hm-group.webp";
import holbaekSynshal from "./assets/customers/holbaek-synshal.webp";
import hydel from "./assets/customers/hydel.webp";
import insektimus from "./assets/customers/insektimus.webp";
import iphouse from "./assets/customers/iphouse.png";
import kempLauritzen from "./assets/customers/kemp-lauritzen.webp";
import klcErhverv from "./assets/customers/klc-erhverv.svg";
import klimadan from "./assets/customers/klimadan.webp";
import miralix from "./assets/customers/miralix.webp";
import mjHydraulik from "./assets/customers/mj-hydraulik.jpg";
import murermesterSylvest from "./assets/customers/murermester-sylvest.webp";
import nyborgMobelhotel from "./assets/customers/nyborg-mobelhotel.webp";
import nyborgPadel from "./assets/customers/nyborg-padel.jpg";
import robotserviceDanmark from "./assets/customers/robot-service-dk.png";
import schouTransport from "./assets/customers/schou-transport.webp";
import visageStudio from "./assets/customers/visage-studio.webp";
import webro from "./assets/customers/webro.webp";
import webvision from "./assets/customers/webvision.webp";
import wuerth from "./assets/customers/wuerth.webp";
import zeroLatencyVr from "./assets/customers/zero-latency-vr.png";
import type { LogoAsset } from "./types";

/**
 * Customer and partner logos for the "trusted by" marquee, in the order of the
 * pitch deck's logo wall (Holbæk Synshal, Miralix, KLC and Hydel first).
 */
export const CUSTOMER_LOGOS: LogoAsset[] = [
  { name: "Holbæk Synshal", image: holbaekSynshal, height: 54 },
  { name: "Miralix", image: miralix, height: 40 },
  { name: "KLC Erhverv", image: klcErhverv, height: 34 },
  { name: "Hydel", image: hydel, height: 39 },
  { name: "Würth", image: wuerth, height: 31 },
  { name: "HM-Group", image: hmGroup, height: 47 },
  { name: "Klimadan", image: klimadan, height: 36 },
  { name: "Evidensia", image: evidensia, height: 54 },
  { name: "BHS Logistics", image: bhsLogistics, height: 54 },
  { name: "Cykelmakker", image: cykelmakker, height: 39 },
  { name: "Nyborg Møbelhotel", image: nyborgMobelhotel, height: 40 },
  { name: "Visage Studio", image: visageStudio, height: 54 },
  { name: "Insektimus", image: insektimus, height: 42 },
  { name: "Murermester Sylvest", image: murermesterSylvest, height: 54 },
  { name: "Zero Latency VR", image: zeroLatencyVr, height: 32 },
  { name: "Gecko Booking", image: geckoBooking, height: 39 },
  { name: "Webro", image: webro, height: 38 },
  { name: "WebVision", image: webvision, height: 28 },
  { name: "Schou Transport", image: schouTransport, height: 54 },
  { name: "Kemp & Lauritzen", image: kempLauritzen, height: 30 },
  { name: "IP House", image: iphouse, height: 40 },
  { name: "Robotservice Danmark", image: robotserviceDanmark, height: 60 },
  { name: "M.J. Hydraulik", image: mjHydraulik, height: 60 },
  { name: "Nyborg Padel", image: nyborgPadel, height: 50 },
  { name: "Backer Consult", image: backerConsult, height: 40 },
  { name: "FamilieTeknikeren", image: familieteknikeren, height: 50 },
  { name: "CloudFactory", image: cloudfactory, height: 26 },
  { name: "Flexkapacitet", image: flexkapacitet, height: 44 },
];
